export const SUPPORTED_LOCALES = ['zh', 'en']
export const LOCALE_STORAGE_KEY = 'site_locale'
export const DEFAULT_LOCALE = 'zh'

/** 分享页 / 管理后台等：不挂 /en 前缀 */
const NO_LOCALE_PREFIX = [
  '/admin',
  '/wifi',
  '/gift',
  '/comment',
  '/order',
  '/electric',
  '/task',
  '/live',
  '/receipt',
  '/card',
  '/quote',
  '/contract',
  '/go'
]

export function isLocalePrefixedPath(path) {
  const p = path || '/'
  return p === '/en' || p.startsWith('/en/')
}

export function localeFromPath(path) {
  return isLocalePrefixedPath(path) ? 'en' : 'zh'
}

export function stripLocalePrefix(path) {
  const p = path || '/'
  if (p === '/en') return '/'
  if (p.startsWith('/en/')) {
    const rest = p.slice(3)
    return rest.startsWith('/') ? rest : `/${rest}`
  }
  return p
}

export function shouldUseLocalePrefix(path) {
  const bare = stripLocalePrefix(path || '/')
  return !NO_LOCALE_PREFIX.some(
    prefix => bare === prefix || bare.startsWith(`${prefix}/`)
  )
}

export function withLocalePrefix(path, locale = DEFAULT_LOCALE) {
  const bare = stripLocalePrefix(path || '/')
  if (locale !== 'en' || !shouldUseLocalePrefix(bare)) {
    return bare
  }
  if (bare === '/') return '/en'
  return `/en${bare}`
}

export function detectLocale() {
  if (typeof window === 'undefined') return DEFAULT_LOCALE
  const fromPath = localeFromPath(window.location.pathname || '/')
  if (fromPath === 'en') return 'en'
  try {
    const saved = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (saved === 'en' || saved === 'zh') return saved
  } catch (_) {
    /* ignore */
  }
  return DEFAULT_LOCALE
}

export function getCurrentLocale() {
  if (typeof window !== 'undefined' && window.__SITE_LOCALE__) {
    return window.__SITE_LOCALE__
  }
  return detectLocale()
}

export function setDocumentLocale(locale) {
  const next = locale === 'en' ? 'en' : 'zh'
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next === 'en' ? 'en' : 'zh-CN'
  }
  if (typeof window !== 'undefined') {
    window.__SITE_LOCALE__ = next
  }
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, next)
  } catch (_) {
    /* ignore */
  }
}

/** 常见导航中文标签 → i18n key（CMS 自定义标签无映射时保留原文） */
export function navLabelKey(item) {
  const path = (item && item.path) || ''
  const type = (item && item.query && item.query.type) || ''
  if (path === '/') return 'nav.home'
  if (path === '/tools' || path.startsWith('/tools')) return 'nav.tools'
  if (path === '/about') return 'nav.about'
  if (path === '/sponsor') return 'nav.sponsor'
  if (path === '/copyright') return 'nav.copyright'
  if (path === '/articles') {
    if (type === 'tech') return 'nav.tech'
    if (type === 'software') return 'nav.software'
    if (type === 'tutorial') return 'nav.tutorial'
    if (type === 'resource') return 'nav.resource'
    if (type === 'news') return 'nav.news'
    return 'nav.articles'
  }
  return null
}
